import { fb, AMPCOL, methodLines, resLines, balRows } from '../lib/floodBal';

// method, data resolution with traffic light and water volume balance of the surface flood run
export function FloodInfo({ m }) {
  const T = fb();
  return (
    <div className="fl-info" data-testid="flood-info">
      <div className={`fl-amp fl-amp-${m.amp}`} data-testid="flood-amp" style={{ borderColor: AMPCOL[m.amp] }}>
        <i style={{ background: AMPCOL[m.amp] }} /><span><b>{T.ampT}: {T.ampS[m.amp]}</b><small>{T.amp[m.amp]}</small></span>
      </div>
      <details data-testid="flood-method"><summary>{T.mT}</summary>{methodLines(m, T).map((x) => <p key={x}>{x}</p>)}</details>
      <div data-testid="flood-resolution"><b>{T.rT}</b>{resLines(m, T).map((x) => <p key={x}>{x}</p>)}</div>
      <div data-testid="flood-balance"><b>{T.bT}</b>
        <table className="fl-bal"><tbody>{balRows(m, T).map(([lb, v, p, ind], i) => (
          <tr key={lb} data-testid={`flood-bal-row-${i}`} className={`ind${ind}`}><td>{lb}</td><td>{v}</td><td>{p}</td></tr>
        ))}</tbody></table>
      </div>
    </div>
  );
}
